import { useEffect } from 'react';

/**
 * Sets `document.title` while the calling component is mounted, restoring
 * the previous title on unmount. Use one per page to compose:
 *   useDocumentTitle('Angel Soares · NexoFácil')
 *
 * Passing `undefined` is a no-op (lets callers await async data before
 * setting the title).
 */
export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
